<div class="dial-container">
  <h1 mat-dialog-title>{{ dialogData.title }}</h1>
  <div class="not-dia-content" mat-dialog-content>
    <div [innerHTML]="dialogData.message"></div>
    <mat-divider></mat-divider>
    <button (click)="onClick()" class="not-dia-btn" color="primary" mat-raised-button>Ok</button>
  </div>
</div>
